import React, { useContext, useState } from 'react';
import { IconWrapper } from '../../../../common/IconWrapper';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import OrderContext from '../../OrderContext';
import { Button } from 'react-bootstrap';

export default function OrderHeaderMoqProgress() {
    const { singleMoq, orderHeader } = useContext(OrderContext);

    const inError =
        singleMoq &&
        (singleMoq.submittedCases + singleMoq.orderCases < singleMoq.minimumOrderQtyNoSurcharge ||
            singleMoq.errorMessages.length > 0);

    const division = orderHeader.supplierName === 'Nisa Ambient' ? 'Ambient' : 'Chill and Freeze';

    const [showMoreErrors, setShowMoreErrors] = useState(false);

    return singleMoq ? (
        <div className={'moq-order-header-container flex'}>
            <div className={'case-summary'}>
                <p>You have ordered </p>
                <p>
                    <strong className={inError ? 'error' : 'success'}>
                        {singleMoq.submittedCases + singleMoq.orderCases}/{singleMoq.minimumOrderQtyNoSurcharge}
                    </strong>
                </p>
                <p> {division} cases.</p>
            </div>
            <ul className={'fa-ul'}>
                {singleMoq.errorMessages.length > 1 ? (
                    <>
                        <li key={0}>
                            <span className="fa-li error">
                                <IconWrapper icon={faExclamationCircle} />
                            </span>
                            {singleMoq.errorMessages[0]}
                        </li>
                        {showMoreErrors &&
                            singleMoq.errorMessages
                                .slice(1, singleMoq.errorMessages.length)
                                .map((message, index) => (
                                    <li key={index + 1}>
                                        <span className="fa-li error">
                                            <IconWrapper icon={faExclamationCircle} />
                                        </span>
                                        {message}
                                    </li>
                                ))}
                        <li key={singleMoq.errorMessages.length + 1}>
                            <span className="fa-li error">
                                <IconWrapper icon={faExclamationCircle} />
                            </span>
                            {!showMoreErrors && singleMoq.errorMessages.length - 1 + ' more issues. '}
                            <Button
                                className={'show-more-button'}
                                variant={'secondary'}
                                onClick={() => setShowMoreErrors(!showMoreErrors)}
                            >
                                {showMoreErrors ? 'Hide' : 'Show'} More
                            </Button>
                        </li>
                    </>
                ) : (
                    singleMoq.errorMessages.map((message, index) => (
                        <li key={index}>
                            <span className="fa-li error">
                                <IconWrapper icon={faExclamationCircle} />
                            </span>
                            {message}
                        </li>
                    ))
                )}
                {singleMoq.infoMessages.map((message, index) => (
                    <li key={index}>
                        <span className="fa-li success">
                            <IconWrapper icon={faCheckCircle} />
                        </span>
                        {message}
                    </li>
                ))}
            </ul>
        </div>
    ) : (
        <></>
    );
}
